import React from "react";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { classNames } from "repoV2/utils/common/render/classNames";
import { PAYMENT_CALCULATION_TYPE } from "repoV2/features/Payments/Payments.constants";
import {
    formatNumberWithCommas,
    roundOff,
} from "repoV2/features/Common/utils/numbers";
import commonStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import CheckoutAccordion from "../../../CheckoutAccordion/CheckoutAccordion";
import CheckoutFormGroupHeader from "../../../CheckoutFormGroupHeader/CheckoutFormGroupHeader";
import PaymentCard from "./modules/PaymentCard/PaymentCard";
import { usePartPaymentDetails } from "./PartPaymentDetails.utils";
import InstallmentsSection from "./modules/InstallmentsSection/InstallmentsSection";
import styles from "./PartPaymentDetails.module.scss";

const PartPaymentDetails = () => {
    const {
        defaultPriceDetails: {
            currency,
            basePrice,
            offerBasePrice,
            showStrikeOffPrice,
        },
        currencyLocale,
        partPaymentCardDetails,
        installmentsList,
        selectedCard,
        handleSelectedCardChange,
        showInstallments,
        setShowInstallments,
    } = usePartPaymentDetails();

    return (
        <CheckoutAccordion
            showExpandIcon={false}
            title={
                <CheckoutFormGroupHeader
                    title="Payment Plan"
                    iconJSX={
                        <PaymentsOutlinedIcon
                            className={styles.headerIconStyle}
                        />
                    }
                />
            }
            expanded
            className={commonStyles.Wrapper}
            classes={{
                root: commonStyles.formGroupRoot,
                disabled: commonStyles.formGroupDisabled,
            }}
            headerClasses={{
                root: classNames(commonStyles.headerRoot, styles.cursorStyle),
                content: commonStyles.headerContent,
                disabled: commonStyles.formGroupDisabled,
                expanded: commonStyles.formGroupExpanded,
            }}
            unmountOnExit
        >
            <div className={styles.paymentCardscontainer}>
                <PaymentCard
                    title="One-time Payment"
                    subTitle="Pay the full amount to book"
                    priceText={
                        <div className={styles.priceContainer}>
                            {showStrikeOffPrice && (
                                <del
                                    className={styles.strikeOffPriceStyle}
                                >{`${currency}${formatNumberWithCommas({
                                    num: roundOff(basePrice, 2),
                                    locale: currencyLocale,
                                })}`}</del>
                            )}
                            <div
                                className={styles.priceTextStyle}
                            >{`${currency}${formatNumberWithCommas({
                                num: roundOff(offerBasePrice, 2),
                                locale: currencyLocale,
                            })}`}</div>
                        </div>
                    }
                    onClick={() =>
                        handleSelectedCardChange(
                            PAYMENT_CALCULATION_TYPE.ONE_TIME_PAYMENT
                        )
                    }
                    isCardSelected={
                        selectedCard ===
                        PAYMENT_CALCULATION_TYPE.ONE_TIME_PAYMENT
                    }
                />
                <PaymentCard
                    title="Part Payment"
                    subTitle="Some amount paid while booking. Rest in scheduled instalments"
                    priceText={
                        <div className={styles.piceTextContainer}>
                            <div className={styles.priceContainer}>
                                <div className={styles.priceTextStyle}>
                                    {partPaymentCardDetails.priceText}
                                </div>
                            </div>
                            <div className={styles.paymentSubText}>
                                +&nbsp;Instalments
                            </div>
                        </div>
                    }
                    onClick={() =>
                        handleSelectedCardChange(
                            PAYMENT_CALCULATION_TYPE.PART_PAYMENT
                        )
                    }
                    isCardSelected={
                        selectedCard === PAYMENT_CALCULATION_TYPE.PART_PAYMENT
                    }
                >
                    <InstallmentsSection
                        installmentsList={installmentsList}
                        currency={currency}
                        currencyLocale={currencyLocale}
                        showInstallments={showInstallments}
                        setShowInstallments={setShowInstallments}
                    />
                </PaymentCard>
            </div>
        </CheckoutAccordion>
    );
};

export default PartPaymentDetails;
